// redex/reportLists/userActions.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  excelClientWiseReportCountApi,
  reportListsApi,
  userReportListsApi,
  fetchStaffAttendanceApi,
  fetchClientQueryStatusApi,
} from "./reportApi";
import { showApiErrorToast } from "../../utils/toastErrorHandler";

/* The session ends on 401 and only on 401 — a request that failed is not a
   token that expired. Clearing on any error signed the whole app out over a
   500 or a missed request, and left the header reading a key that was no
   longer there. Same guard as taskActions.js. */
const endSessionIfUnauthorized = (err) => {
  if (err?.response?.status !== 401) return;
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};



export const reportListsApis = createAsyncThunk(
  "reportListsApi/reportListsApi",
  async (payload, { rejectWithValue }) => {
    try {
      return await reportListsApi(payload);
    } catch (err) {
      endSessionIfUnauthorized(err);

      showApiErrorToast(err?.response?.data?.error || err.message);

      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  },
);

export const userReportListsApis = createAsyncThunk(
  "userReportListsApi/userReportListsApi",
  async (payload, { rejectWithValue }) => {
    try {
      return await userReportListsApi(payload);
    } catch (err) {
      endSessionIfUnauthorized(err);

      showApiErrorToast(err?.response?.data?.error || err.message);

      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  },
);

export const excelClientWiseReportCountApis = createAsyncThunk(
  "excelClientReportApi/excelClientReportApi",
  async (payload, { rejectWithValue }) => {
    try {
      return await excelClientWiseReportCountApi(payload);
    } catch (err) {
      endSessionIfUnauthorized(err);

      showApiErrorToast(err?.response?.data?.error || err.message);

      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  },
);

/* Fetched on demand by the management report rather than on page load: two
   more calls on every visit to a screen that may never open that report is
   two calls wasted. */
export const staffAttendanceApis = createAsyncThunk(
  "report/staffAttendance",
  async (payload, { rejectWithValue }) => {
    try {
      return await fetchStaffAttendanceApi(payload);
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const clientQueryStatusApis = createAsyncThunk(
  "report/clientQueryStatus",
  async (payload, { rejectWithValue }) => {
    try {
      return await fetchClientQueryStatusApi(payload);
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  },
);
